import store from '../apps/store/store'
import { setCart, setCartOpen, setUpsells } from '../apps/store/cartSlice'
import { getXgenProducts } from './Product.js'

const cartSuccessBanner = document.querySelector('[data-cart-add-success]')
const state = {
  cartTimer: 0,
  interval: null,
}
const showCartBanner = (message) => {
  cartSuccessBanner.innerHTML = message
  cartSuccessBanner.classList.add('z-full')
  cartSuccessBanner.classList.remove('-z-1', 'opacity-0')
  cartSuccessBanner.setAttribute('aria-hidden', false)
  state.cartTimer = 3000
  state.interval = setInterval(() => {
    if(state.cartTimer <= 0) {
      clearInterval(state.interval)
      cartSuccessBanner.classList.remove('z-full')
      cartSuccessBanner.classList.add('-z-1', 'opacity-0')
      cartSuccessBanner.setAttribute('aria-hidden', true)
    } else {
      state.cartTimer -= 200
    }
  }, 200) 
}

export const getCart = (callback = null, open = true, buttonElement = null) => {
  fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    return response.json()
  })
  .then(cart => {
    console.log(cart)
    store.dispatch(setCart(cart))
    store.dispatch(setCartOpen(open))
    updateUpsells()
    if(buttonElement) buttonElement.disabled = false
    if(callback) callback(cart)
  })
  .catch((error) => {
    console.error('Error:', error)
  })
}

window.getCart = getCart

export const addLineItems = (callback = null, items = [], open = true, buttonElement = null) => {
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'items': items
    })
  })
  .then(response => {
    return response.json()
  })
  .then(response => {
    console.log(response)
    showCartBanner('Item successfully added to cart')
    getCart(callback, open, buttonElement)
  })
  .catch((error) => {
    console.error('Error:', error)
  })
}
window.addLineItems = addLineItems

export const makeLineItem = (variantId, quantity, tags) => {
  const properties = {}
  if(tags.includes('Final Sale')) properties['Final Sale'] = 'Yes'
  if(tags.includes('pre-order')) {
    let deliveryTag = null
    tags.forEach((tag) => {
      if(tag.includes('delivery_')) deliveryTag = tag
    })
    if(deliveryTag) properties['Expected Ship Date'] = deliveryTag.replace('delivery_', '').replaceAll('/', '-')
  }
  return {
    id: variantId,
    quantity,
    properties,
  }
}
window.makeLineItem = makeLineItem

export const changeLineItem = (callback = null, item = {}, open = true, message = null) => {
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(item)
  })
  .then(response => {
    return response.json()
  })
  .then(cart => {
    console.log(cart)
    
    // Determine the appropriate message based on the action
    let announcementMessage = message || 'Cart is successfully updated'
    
    // If no specific message provided, try to determine based on quantity
    if (!message && item.quantity !== undefined) {
      if (item.quantity === 0) {
        announcementMessage = 'Item was successfully removed from cart'
      } else if (item.quantity > 0) {
        announcementMessage = `Quantity updated to ${item.quantity}`
      }
    }
    
    showCartBanner(announcementMessage)
    store.dispatch(setCart(cart))
    store.dispatch(setCartOpen(open))
    updateUpsells()
    if(callback) callback(cart)
  })
  .catch((error) => {
    console.error('Error:', error)
    showCartBanner('Error updating cart')
  })
}

export const updateCart = (callback = null, body = {}, open = true) => {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
  .then(response => {
    return response.json()
  })
  .then(cart => {
    console.log(cart)
    showCartBanner('Cart is successfully updated')
    store.dispatch(setCart(cart))
    store.dispatch(setCartOpen(open))
    updateUpsells()
    if(callback) callback(cart)
  })
  .catch((error) => {
    console.error('Error:', error)
  })
}

export const updateUpsells = () => {
  const cartDrawerWrapper = document.querySelector('[data-cart-drawer]')
  const cartProps = JSON.parse(cartDrawerWrapper.getAttribute('props'))
  if(cartProps.xgenId) {
    const excludeSale = cartProps.excludeSale == true || cartProps.excludeSale == 'true'
    if(typeof getXgenPredictions != 'undefined') {
      getXgenPredictions(cartProps.xgenId).then((results) => {
        const skus = results.map((result) => result.variants[0].sku).filter(Boolean)
        getXgenProducts((results) => {
          console.log(results)
          const filteredResults = excludeSale ? results.filter((result) => !result.tags.includes('Sale') && !result.tags.includes('Final Sale')) : results
          store.dispatch(setUpsells(filteredResults))
          setTimeout(() => {
            window.setupProductTiles(cartDrawerWrapper.querySelectorAll('[product-tile]:empty'))
            if(cartDrawerWrapper.querySelector('[data-inline-cart-swiper]')) {
              if(cartDrawerWrapper.querySelector('[data-inline-cart-swiper]').swiper) cartDrawerWrapper.querySelector('[data-inline-cart-swiper]').swiper.destroy(true, true)
              new Swiper(cartDrawerWrapper.querySelector('[data-inline-cart-swiper]'), {
                speed: 500,
                loop: true,
                spaceBetween: 16,
                slidesPerView: 2,
                breakpoints: {
                  300: {
                    slidesPerView: 2.2,
                    spaceBetween: 8,
                  },
                  375: {
                    slidesPerView: 2.2,
                    spaceBetween: 12,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                  }
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                }
              })
            }
          }, 300)
        }, skus)
      })
    }
  }
}
window.upsellInited = false
window.updateUpsells = updateUpsells